import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../UI/Typography'
import Button from '../UI/Button'
import { device } from '../../utils/helpers'
import NotFoundIcon from '../UI/Icons/404Icon'

// Features
const Wrapper = styled.div`
  margin-top: 80px;

  @media ${device.tablet} {
    margin-top: 120px;
  }
`

const Section = styled.section`
  background: ${props => props.grey ? props.theme.color.bgLight : '#fff'};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const BigTitle = styled.div`
  padding: 3.5rem;
  text-align: center;

  @media ${device.laptop} {
    width: 500px;
  }

  @media ${device.laptopL} {
    width: 700px;
  }
`

const ButtonWrapper = styled.div`
  padding: 3.5rem 0;

  @media ${device.tablet} {
    padding: 3.5rem 0;
  }

  @media ${device.laptop} {
    padding-bottom: 4rem;
  }
`

const TextWrapper = styled.div`
  padding-top: 3.5rem;
  width: 50%;

  @media ${device.tablet} {
    width: 30%;
    padding-top: 2.5rem;
  }

  @media ${device.laptop} {
    width: 20%;
    padding-top: 4rem;
  }
`

const NFIcon = styled(NotFoundIcon)`
  width: 100px;

  @media ${device.tablet} {
    width: 9.510416666666667vw;
  }
`

class NotFound extends Component {
  render () {
    return (
      <Wrapper>
        <Helmet>
          <title>Pagina non trovata</title>
        </Helmet>
        <Section>
          <BigTitle>
            <Typography variant='h3' type='title'>
              OOOOOOPPSS...<br />
              COURT NOT FOUND!
            </Typography>
          </BigTitle>
          <NFIcon />
          <TextWrapper>
            <Typography variant='h6'>
              Sembra proprio che qualcosa sia andato storto!
            </Typography>
          </TextWrapper>
          <ButtonWrapper>
            <Button secondary href='https://noleggiocampi.it/'>TORNA ALLA HOME</Button>
          </ButtonWrapper>
        </Section>
      </Wrapper>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/Pages/404.js